import Script from 'next/script';
import { ValidatedScripts } from '../response-data-validator';
interface Props {
  yektanetData: ValidatedScripts['yektanet'];
}
export const YektanetScript = ({
  yektanetData
}: Props) => {
  if (!yektanetData?.enabled) return null;
  return <>
            <Script defer id='yektanet' strategy='afterInteractive' dangerouslySetInnerHTML={{
      __html: `!function (t, e, n) {
t.yektanetAnalyticsObject = n, t[n] = t[n] || function () {
t[n].q.push(arguments)
}, t[n].q = t[n].q || [];
var a = new Date, r = a.getFullYear().toString() + "0" + a.getMonth() + "0" + a.getDate() + "0" + a.getHours(),
c = e.getElementsByTagName("script")[0], s = e.createElement("script");
s.id = "ua-script-UszIh9gp"; s.dataset.analyticsobject = n;
s.async = 1; s.type = "text/javascript";
s.src = "https://cdn.yektanet.com/rg_woebegone/scripts_v3/UszIh9gp/rg.complete.js?v=" + r, c.parentNode.insertBefore(s, c)
}(window, document, "yektanet");`
    }} data-sentry-element="Script" data-sentry-source-file="yektanet.tsx" />

            <Script defer id='yektanet2' strategy='afterInteractive' dangerouslySetInnerHTML={{
      __html: `!function (t, e, n) {
t.yektanetAnalyticsObject = n, t[n] = t[n] || function () {
t[n].q.push(arguments)
}, t[n].q = t[n].q || [];
var a = new Date, r = a.getFullYear().toString() + "0" + a.getMonth() + "0" + a.getDate() + "0" + a.getHours(),
c = e.getElementsByTagName("script")[0], s = e.createElement("script");
s.id = "ua-script-16UWPt63"; s.dataset.analyticsobject = n;
s.async = 1; s.type = "text/javascript";
s.src = "https://cdn.yektanet.com/rg_woebegone/scripts_v3/16UWPt63/rg.complete.js?v=" + r, c.parentNode.insertBefore(s, c)
}(window, document, "yektanet");`
    }} data-sentry-element="Script" data-sentry-source-file="yektanet.tsx" />
        </>;
};